import { Stepper, styled } from "@mui/material";

export const StyledStepper = styled(Stepper)(() => ({
  "& .MuiStepLabel-iconContainer.Mui-active": {
    transform: "scale(1.3)",
  },
}));
